import React from 'react';

import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Button } from '@mui/material';

import { useGetSupplier } from '~/hooks/apis/tours/useTourSuppliers';

import { vendorPath } from '../nativeTourModel';

interface Props {
  supplierId: string;
  name: string;
}

/** A supplier, linked to its vendor page when it came from a Salesforce contract. */
export default function NativeTourSupplierLink({ supplierId, name }: Props) {
  const { data: supplier } = useGetSupplier(supplierId);
  const sourceSupplierId = supplier?.sourceSupplierId ?? null;

  if (!sourceSupplierId) {
    return <Button disabled>{name}</Button>;
  }
  return (
    <Button
      variant="text"
      endIcon={<OpenInNewIcon fontSize="small" />}
      href={vendorPath(sourceSupplierId)}
      target="_blank"
      rel="noreferrer"
    >
      {name}
    </Button>
  );
}
